import { connect } from "react-redux";
import styles from "./index.module.less"
const Dashboard = ({ auth }) => {
  return (
    <div  className={styles.welcome}>
      <p className={styles.welcomeText}>您好，欢迎登录甜橙ERP管理系统</p>
      <p className={styles.welcomeSubText}>Welcome to the TianCheng ERP system</p>
      <img className={styles.welcomeImage} src="/assets/welcome-bg.png" alt="" />
    </div>
  );
};
export default connect((state) => ({ auth: state.auth }))(Dashboard);
